<div *ngIf="isGebruikerIngelogd()" (click)="openDialog()">
    <i class="icon-voting"></i>
</div>




